(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ha-catalogue-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
  const source = document.querySelector('[data-ha-range-labels]');
  if (!source) return;
  const labels = JSON.parse(source.textContent);
  let sequence = 0;
  const toolbarAnchors = [];
  function keepControlsVisible(bar, range) {
    const anchor = document.createElement('div');
    anchor.className = 'ha-range-toolbar-anchor';
    bar.before(anchor);
    anchor.append(bar);
    const entry = { anchor, bar, range: range || bar.closest('.collection-products-section, [data-search-catalogue], section') || anchor.parentElement };
    toolbarAnchors.push(entry);
    bar.classList.add('ha-range-sticky-controls');
    let queued = false;
    let pinned = false;
    let naturalHeight = 0;
    const header = document.getElementById('site-header');
    function update() {
      queued = false;
      if (!bar.isConnected) return;
      const bounds = anchor.getBoundingClientRect();
      const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0, window.visualViewport?.offsetTop || 0);
      const eligible = toolbarAnchors.filter(item => {
        const rect = item.anchor.getBoundingClientRect();
        return item.anchor.isConnected && rect.width > 0 && rect.top <= headerBottom
          && item.range.getBoundingClientRect().bottom > headerBottom + item.bar.getBoundingClientRect().height;
      });
      const active = eligible.sort((a, b) => a.anchor.compareDocumentPosition(b.anchor) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1).at(-1);
      const next = toolbarAnchors.find(item => item !== entry && anchor.compareDocumentPosition(item.anchor) & Node.DOCUMENT_POSITION_FOLLOWING
        && item.anchor.getBoundingClientRect().width > 0 && item.anchor.getBoundingClientRect().top > headerBottom
        && item.anchor.getBoundingClientRect().top < headerBottom + bar.getBoundingClientRect().height);
      const shouldPin = bounds.width > 0 && active === entry && !next;
      if (!pinned) naturalHeight = bounds.height;
      if (shouldPin) {
        anchor.style.height = naturalHeight + 'px';
        bar.style.setProperty('--ha-range-pin-top', headerBottom + 'px');
        bar.style.setProperty('--ha-range-pin-left', bounds.left + 'px');
        bar.style.setProperty('--ha-range-pin-width', bounds.width + 'px');
      } else {
        anchor.style.removeProperty('height');
      }
      pinned = shouldPin;
      bar.classList.toggle('is-pinned', pinned);
      const barBounds = bar.getBoundingClientRect();
      const queryField = bar.querySelector('.ha-range-search-query .field');
      if (queryField) {
        const viewportBottom = (window.visualViewport?.offsetTop || 0) + (window.visualViewport?.height || innerHeight);
        bar.style.setProperty('--ha-range-query-dropdown-offset', Math.max(0, barBounds.bottom - queryField.getBoundingClientRect().bottom) + 'px');
        bar.style.setProperty('--ha-range-predictive-max-height', Math.max(80, Math.min(420, viewportBottom - barBounds.bottom - 12)) + 'px');
      }
      if (pinned || !active) document.documentElement.style.setProperty('--ha-range-controls-clearance', (pinned ? headerBottom + barBounds.height + 16 : headerBottom + 16) + 'px');
    }
    function schedule() {
      if (!queued) { queued = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
    if (window.ResizeObserver) {
      const observer = new ResizeObserver(schedule);
      observer.observe(anchor);
      observer.observe(bar);
      if (header) observer.observe(header);
    }
    schedule();
  }
  function enhance(aside) {
    if (aside.dataset.rangeDrawerReady) return;
    const owner = aside.closest('[data-search-catalogue], .collection-products-section');
    const original = aside.querySelector(':scope > details');
    const content = original?.querySelector('.all-products-route-filters__content');
    if (!owner || !original || !content) return;
    aside.dataset.rangeDrawerReady = 'true';
    const id = 'ha-range-drawer-' + (++sequence);
    const dialog = document.createElement('dialog');
    dialog.className = 'ha-range-filter-dialog';
    dialog.id = id;
    dialog.setAttribute('aria-labelledby', id + '-heading');
    const header = document.createElement('div');
    header.className = 'ha-range-filter-header';
    const heading = document.createElement('h2');
    heading.id = id + '-heading';
    heading.textContent = labels.heading;
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'ha-range-filter-close';
    close.setAttribute('aria-label', labels.close);
    close.textContent = '×';
    header.append(heading, close);
    const scroll = document.createElement('div');
    scroll.className = 'ha-range-filter-scroll';
    original.open = true;
    scroll.append(original);
    const footer = document.createElement('div');
    footer.className = 'ha-range-filter-footer';
    const count = document.createElement('p');
    count.className = 'ha-range-filter-count';
    count.setAttribute('aria-live', 'polite');
    const done = document.createElement('button');
    done.type = 'button';
    done.className = 'ha-range-filter-results';
    done.textContent = labels.results;
    footer.append(count, done);
    dialog.append(header, scroll, footer);
    aside.append(dialog);
    function group(node, label, open) {
      if (!node) return;
      const details = document.createElement('details');
      details.className = 'ha-range-filter-group';
      details.open = open;
      const summary = document.createElement('summary');
      summary.textContent = label;
      node.before(details);
      details.append(summary, node);
    }
    group(content.querySelector('.collection-catalogue-filters__vehicle'), labels.vehicle, true);
    group(content.querySelector('[data-collection-taxonomy-filter]'), labels.category, false);
    group(content.querySelector('[data-all-products-secondary-brand]')?.closest('label'), labels.brand, false);
    group(content.querySelector('[data-all-products-secondary-price]')?.closest('label'), labels.price, false);
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'ha-range-filter-trigger';
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', id);
    trigger.setAttribute('aria-expanded', 'false');
    trigger.textContent = labels.filters;
    const toolbar = owner.querySelector('.collection-catalogue-range-toolbar__controls, .collection-category__all-products-controls, .ha-search-catalogue__toolbar');
    if (toolbar) toolbar.prepend(trigger); else aside.before(trigger);
    if (toolbar) {
      if (toolbar.matches('.ha-search-catalogue__toolbar')) {
        const query = owner.closest('.template-search')?.querySelector('.template-search__search');
        if (query) {
          query.classList.add('ha-range-search-query');
          toolbar.prepend(query);
        }
      }
      keepControlsVisible(toolbar.closest('.collection-catalogue-range-toolbar') || toolbar, owner);
    }
    const layout = aside.closest('.collection-catalogue-filter-layout, .ha-search-catalogue__layout');
    layout?.classList.add('ha-range-filter-layout');
    aside.classList.add('ha-range-filter-host');
    const readCount = () => {
      const value = owner.querySelector('[data-all-products-count-status], [data-search-count], [data-all-products-count]')?.textContent?.trim() || '';
      if (count.textContent !== value) count.textContent = value;
      const keys = [['product_area'], ['product_category', 'brand_category'], ['product_type'], ['catalogue_brand', 'filter.p.vendor'], ['catalogue_price', 'price_band'], ['vehicle_selection_id', 'vehicle_id', 'vehicle_make'], ['show_universal', 'show_universal_products']];
      const params = new URLSearchParams(location.search);
      const active = keys.filter(group => group.some(key => params.get(key) && !['false', '0'].includes(params.get(key)))).length;
      const text = labels.filters + (active ? ' (' + active + ')' : '');
      if (trigger.textContent !== text) trigger.textContent = text;
    };
    trigger.addEventListener('click', () => {
      readCount();
      original.open = true;
      dialog.showModal();
      document.documentElement.classList.add('ha-range-dialog-open');
      trigger.setAttribute('aria-expanded', 'true');
      close.focus({ preventScroll: true });
    });
    close.addEventListener('click', () => dialog.close());
    done.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('cancel', event => {
      const openPicker = dialog.querySelector('[data-sbv-combobox-panel]:not([hidden])');
      if (openPicker) event.preventDefault();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('ha-range-dialog-open');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus({ preventScroll: true });
    });
    const countSource = owner.querySelector('[data-all-products-count-status], [data-search-count], [data-all-products-count]');
    if (countSource) new MutationObserver(readCount).observe(countSource, { childList: true, characterData: true, subtree: true });
    aside.addEventListener('change', () => setTimeout(readCount, 0));
    window.addEventListener('popstate', readCount);
    readCount();
    if (new URLSearchParams(location.search).get('ha_filters') === 'open') {
      toolbar?.scrollIntoView({ block: 'start' });
      trigger.click();
      const url = new URL(location.href);
      url.searchParams.delete('ha_filters');
      history.replaceState(history.state, '', url);
    }
  }
  function enhanceSharedRange(grid, destination) {
    // A recommendation on a collection page is a shortcut to its full range,
    // not a second product-matching implementation with a different toolbar.
    if (destination.pathname.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '')) return false;
    const sourceBar = document.querySelector('.collection-products-section .collection-catalogue-range-toolbar');
    const sourceSearch = sourceBar?.querySelector('[data-all-products-search-input]');
    const sourceControls = sourceBar?.querySelector('.collection-catalogue-range-toolbar__controls');
    const sourceFilter = sourceControls?.querySelector('.ha-range-filter-trigger');
    if (!sourceSearch || !sourceControls || !sourceFilter) return false;
    const form = document.createElement('form');
    form.className = 'collection-catalogue-range-toolbar ha-range-shared-toolbar';
    form.setAttribute('role', 'search');
    form.setAttribute('aria-label', labels.searchRange);
    form.append(sourceSearch.closest('label').cloneNode(true), sourceControls.cloneNode(true));
    form.querySelectorAll('*').forEach(node => {
      [...node.attributes].filter(attr => attr.name.startsWith('data-all-products-') || attr.name === 'id' || attr.name === 'for').forEach(attr => node.removeAttribute(attr.name));
    });
    const input = form.querySelector('input');
    const filter = form.querySelector('.ha-range-filter-trigger');
    const selects = [...form.querySelectorAll('select')];
    const originals = [...sourceControls.querySelectorAll('select')];
    const showRange = () => sourceBar.scrollIntoView({ block: 'start' });
    const sync = () => {
      if (document.activeElement !== input) input.value = sourceSearch.value;
      selects.forEach((select, index) => { select.value = originals[index].value; });
      filter.textContent = sourceFilter.textContent;
      filter.setAttribute('aria-expanded', sourceFilter.getAttribute('aria-expanded') || 'false');
    };
    input.addEventListener('input', () => {
      sourceSearch.value = input.value;
      sourceSearch.dispatchEvent(new Event('input', { bubbles: true }));
    });
    form.addEventListener('submit', event => { event.preventDefault(); showRange(); });
    selects.forEach((select, index) => select.addEventListener('change', () => {
      if (originals[index].matches('[data-all-products-sort-select]')) {
        // Sorting may navigate before the existing search debounce completes.
        const url = new URL(location.href);
        ['range_search', 'brand_search', 'q'].forEach(key => url.searchParams.delete(key));
        if (input.value.trim()) url.searchParams.set('range_search', input.value.trim());
        url.hash = sourceBar.closest('.collection-products-section')?.id || '';
        history.replaceState(history.state, '', url);
      }
      originals[index].value = select.value;
      originals[index].dispatchEvent(new Event('change', { bubbles: true }));
      showRange();
    }));
    filter.addEventListener('click', () => { showRange(); sourceFilter.click(); });
    sourceBar.addEventListener('input', sync);
    sourceBar.addEventListener('change', sync);
    window.addEventListener('popstate', sync);
    new MutationObserver(sync).observe(sourceFilter, { childList: true, attributes: true, attributeFilter: ['aria-expanded'] });
    const sourceCount = sourceBar.querySelector('[data-all-products-count-status]');
    if (sourceCount) new MutationObserver(sync).observe(sourceCount, { childList: true, characterData: true, subtree: true });
    window.addEventListener('load', sync, { once: true });
    sync();
    grid.before(form);
    keepControlsVisible(form, grid.closest('section') || grid.parentElement);
    return true;
  }
  function enhanceFeaturedRange(grid) {
    if (grid.hasAttribute('data-ha-static-range')) return;
    if (grid.dataset.rangeBrowseReady || grid.closest('[data-search-catalogue], .collection-products-section')) return;
    if (!grid.querySelector('.product-card, .product-card-wrapper')) return;
    grid.dataset.rangeBrowseReady = 'true';
    const destination = new URL(grid.dataset.haRangeUrl || labels.rangeUrl, location.origin);
    if (destination.origin !== location.origin || !/^\/collections\/[^/]+\/?$/.test(destination.pathname)) {
      destination.href = new URL('/collections/all-products', location.origin).href;
    }
    if (enhanceSharedRange(grid, destination)) return;
    const form = document.createElement('form');
    form.className = 'ha-range-browse-toolbar';
    form.action = destination.pathname;
    form.setAttribute('role', 'search');
    const field = document.createElement('div');
    field.className = 'ha-range-browse-search';
    const input = document.createElement('input');
    input.type = 'search';
    input.name = 'range_search';
    input.placeholder = destination.pathname === '/collections/all-products' ? labels.searchAll : labels.searchRange;
    input.setAttribute('aria-label', input.placeholder);
    const submit = document.createElement('button');
    submit.type = 'submit';
    submit.className = 'ha-range-browse-submit';
    submit.textContent = labels.search;
    field.append(input, submit);
    const filters = document.createElement('button');
    filters.type = 'button';
    filters.className = 'ha-range-filter-trigger';
    filters.textContent = labels.filters;
    const sort = document.createElement('select');
    sort.name = 'sort_by';
    sort.setAttribute('aria-label', labels.sort);
    [['manual',labels.featured],['title-ascending',labels.az],['price-ascending',labels.priceLow],['price-descending',labels.priceHigh]].forEach(([value,label])=>sort.add(new Option(label,value)));
    function browse(openFilters) {
      const url = new URL(destination);
      if (input.value.trim()) url.searchParams.set('range_search', input.value.trim());
      url.searchParams.set('sort_by', sort.value);
      if (openFilters) url.searchParams.set('ha_filters', 'open');
      url.hash = 'ProductGridContainer';
      location.assign(url);
    }
    form.addEventListener('submit', event => { event.preventDefault(); browse(false); });
    filters.addEventListener('click', () => browse(true));
    sort.addEventListener('change', () => browse(false));
    form.append(field, filters, sort);
    grid.before(form);
    keepControlsVisible(form, grid.closest('section') || grid.parentElement);
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-all-products-secondary-filters]').forEach(enhance);
    scope.querySelectorAll('.product-grid, .tuning-product-group__grid').forEach(enhanceFeaturedRange);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  let refreshQueued = false;
  new MutationObserver(records => {
    if (refreshQueued || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1))) return;
    refreshQueued = true;
    requestAnimationFrame(() => { refreshQueued = false; init(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

})();
